// extracted by css-extract-rspack-plugin
export default {"messageContainer":"messageContainer-tsqTG","messageBody":"messageBody-EFW8R"};